import React, {Component} from "react"
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";
import {withRouter} from "react-router-dom";
import globalMiddleware from "../../hocs/globalMiddleware";
import {
    getHospitalProfile,
    getHospitalDoctors,
    clearHospitalDoctorsList,
    clearHospitalProfile
} from "../../store/actions/hospitalActions";
import {clearError500} from "../../store/actions/globalActions";
import ProgressiveImage from "react-progressive-image-loading";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
    LinkedinIcon,
} from 'react-share';
import HospitalAbout from "./HospitalAbout";
import HospitalDoctors from "./HospitalDoctors";
import {setHospitalProfileSkeleton} from "../../skeleton";
import Maintenance from "../../views/user/UserHistory";
import NoMatch from "./DoctorProfile";
import {goToDoctorProfileFromBooking} from "../../store/actions/doctorActions";

class HospitalProfile extends Component {
    constructor(props) {
        super(props);
        this.id = this.props.match.params.id;
        this.state = {
            activeTab: true,
            hospitalDoctorsLimit: 4,
            hospitalDoctorsOffset: 0,
        }
    }

    componentDidMount() {
        this.props.clearError500();
        this.props.getHospitalProfile(this.id);
        this.props.setWindowRef ? this.props.setWindowRef() : console.log("loading props");
    }
    handelBookingFromMobile = () => {
        this.props.goToDoctorProfileFromBooking();
    };
    getHospitalDoctors = (e) => {
        e.preventDefault();
        let siblings = document.querySelectorAll('.tab.active');
        e.currentTarget.classList.add("active");
        for (let i = 0; i < siblings.length; i++) {
            siblings[i].classList.remove('active');
        }
        this.setState({
            activeTab: false,
        });
        this.props.clearHospitalDoctorsList();
        this.props.getHospitalDoctors(this.id, -1, -1, this.state.hospitalDoctorsLimit, this.state.hospitalDoctorsOffset);
    };
    getHospitalData = (e) => {
        e.preventDefault();
        let siblings = document.querySelectorAll('.tab.active');
        e.currentTarget.classList.add("active");
        for (let i = 0; i < siblings.length; i++) {
            siblings[i].classList.remove('active');
        }
        this.setState({
            activeTab: true,
        });
        this.props.clearHospitalProfile();
        this.props.getHospitalProfile(this.id);
    };
    showMoreHospitalDoctors = (e) => {
        e.preventDefault();
        this.setState({
                hospitalDoctorsOffset: this.state.hospitalDoctorsOffset + this.state.hospitalDoctorsLimit,
            }, () =>
                this.props.getHospitalDoctors(this.id, -1, -1, this.state.hospitalDoctorsLimit, this.state.hospitalDoctorsOffset)
        )
    };

    render() {
        const {hospital, currentHospitalNotFound, showMoreHospitalDoctorsLoading, noMoreHospitalDoctors,hospitalIsLoading, aboutHospitalIsLoading, hospitalDoctors, hospitalDoctorsIsLoading, error500, translate} = this.props;
        if (error500) {
            return (
                <Maintenance/>
            )
        }
        if (currentHospitalNotFound) {
            return <NoMatch/>
        }
        return (
            !hospitalIsLoading ?
                <div className="container" id="hospital_profile">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="hospital-details-card">
                                <div className="hospital-image">
                                    <div className="avatar">
                                        <ProgressiveImage
                                            preview="/images/doctor-image-placeholder.png"
                                            src={hospital.profile.image}
                                            render={(src, style) => <img className="full-width"
                                                                         alt="head" src={src}
                                                                         style={style}/>}
                                        /></div>
                                </div>
                                <div className="hospital-details-data">
                                    <h1>{hospital.profile.name}</h1>
                                    <p className="capitalized">{translate('different_specialities')}</p>
                                    <div className="share-area">
                                        <FacebookShareButton
                                            url={window.location.origin + "/doctor/" + hospital.profile.unique_id}>
                                            <FacebookIcon size={32} round/>
                                        </FacebookShareButton>
                                        <LinkedinShareButton
                                            url={window.location.origin + "/doctor/" + hospital.profile.unique_id}>
                                            <LinkedinIcon size={32} round/>
                                        </LinkedinShareButton>
                                        <TwitterShareButton
                                            url={window.location.origin + "/doctor/" + hospital.profile.unique_id}>
                                            <TwitterIcon size={32} round/>
                                        </TwitterShareButton>
                                        <WhatsappShareButton
                                            url={window.location.origin + "/doctor/" + hospital.profile.unique_id}>
                                            <WhatsappIcon size={32} round/>
                                        </WhatsappShareButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="text-center flex capitalized appointment-tabs cursor-pointer">
                            <div onClick={(e) => this.getHospitalData(e)}
                                 className="tab-left tab active">{translate("about")}</div>
                            <div onClick={(e) => this.getHospitalDoctors(e)}
                                 className="tab-right tab">{translate("doctors")}</div>
                        </div>
                    </div>
                    <HospitalAbout
                        toggleShowMore={(e, num, stateVariable, collapsePropsLength) => this.props.toggleShowMore(e, num, stateVariable, collapsePropsLength)}
                        hospital={hospital} activeTab={this.state.activeTab} language={this.props.language}
                        numOfIncCompanies={this.props.numOfIncCompanies}
                        aboutHospitalIsLoading={aboutHospitalIsLoading}/>


                    <HospitalDoctors hospital={hospital} language={this.props.language}
                                     hospitalDoctors={hospitalDoctors}
                                     hospitalDoctorsIsLoading={hospitalDoctorsIsLoading}
                                     activeTab={this.state.activeTab}
                                     noMoreHospitalDoctors={noMoreHospitalDoctors}
                                     showMoreHospitalDoctorsLoading={showMoreHospitalDoctorsLoading}
                                     showMoreHospitalDoctors={(e) => this.showMoreHospitalDoctors(e)}
                                     handelBookingFromMobile={() => this.handelBookingFromMobile}/>
                </div>
                :
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {setHospitalProfileSkeleton(3)}
                        </div>
                    </div>
                </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        hospital: state.hospital.hospital,
        currentHospitalNotFound: state.hospital.currentHospitalNotFound,
        hospitalIsLoading: state.hospital.hospitalIsLoading,
        aboutHospitalIsLoading: state.hospital.aboutHospitalIsLoading,
        showMoreHospitalDoctorsLoading: state.hospital.showMoreHospitalDoctorsLoading,
        noMoreHospitalDoctors: state.hospital.noMoreHospitalDoctors,

        hospitalDoctors: state.hospital.hospitalDoctors,
        hospitalDoctorsIsLoading: state.hospital.hospitalDoctorsIsLoading,

        goToDoctorProfileFromBooking: state.doctor.goToDoctorProfileFromBooking,

        error500: state.global.error500,
    }
};


const mapDispatchToProps = (dispatch) => {
    return {
        getHospitalProfile: (hospital_id) => dispatch(getHospitalProfile(hospital_id)),
        getHospitalDoctors: (hospital_id, speciality_id, branch_id, limit, offset) => dispatch(getHospitalDoctors(hospital_id, speciality_id, branch_id, limit, offset)),
        clearError500: () => dispatch(clearError500()),
        clearHospitalDoctorsList: () => dispatch(clearHospitalDoctorsList()),
        clearHospitalProfile: () => dispatch(clearHospitalProfile()),
        goToDoctorProfileFromBooking: () => dispatch(goToDoctorProfileFromBooking()),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(withRouter(globalMiddleware(HospitalProfile))))